<template>
  <div class="refreshVan">
    <div class="dc-header dc-card">
      <van-row>
        <van-col span="6">
          <div class="dc-image">
            <van-image :src="'http://huyi-1252763274.cossh.myqcloud.com/' + doctorInfo.DOCTOR_IMG"></van-image>
          </div>
        </van-col>
        <van-col span="18">
          <div class="dc-title">
            <div class="docName">{{ doctorInfo.DOCTOR_NAME }}</div>
            <div class="docTech">{{ doctorInfo.TECHNICAL }}</div>
          </div>
        </van-col>
      </van-row>
    </div>

    <div class="week-title">门诊排班</div>
    <div class="weeks">
      <div class="week-item" v-for="docDateCalc in docDateCalcs" :key="docDateCalc.DOCTOR_SCHEDULE_ID"
           @click="function(){ currentDocDateCalc= docDateCalc}" :class="{active:docDateCalc== currentDocDateCalc}">
        <div class="item-value">{{ weekdays[docDateCalc.WEEKDT - 1] }}</div>
        <div class="item-value">{{ getDateShow(docDateCalc.DOC_DATE) }}</div>
      </div>
    </div>

    <div class="detail-list">
      <van-row>
        <van-col span="2">
          <div class="detail-item">全天</div>
        </van-col>
        <van-col span="15">
          <div class="detail-info">
            <div class="info-tag">到院就诊</div>
            <div class="info-postion">{{doctorInfo.DOMAIN}}</div>
          </div>
        </van-col>
        <van-col span="7">
          <div class="detail-time">
            <div class="appoint" v-if="currentDocDateCalc.SY_QTY && currentDocDateCalc.SY_QTY > 0  && currentDocDateCalc.TZ_TAG== false"
                 @click="postBook">预约</div>
            <div class="appoint_disable" v-if="currentDocDateCalc.TZ_TAG== true">停诊</div>
            <div class="residue">{{ doctorInfo.FIRST_FEE }}元 | 剩余{{ currentDocDateCalc.SY_QTY ? currentDocDateCalc.SY_QTY : 0 }}个</div>
          </div>
        </van-col>
      </van-row>
    </div>

    <div class="menu-title">个人介绍</div>
    <div class="dc-desc">
      <div class="desc-content">{{ doctorInfo.INTRODUCTION }}</div>
    </div>
  </div>
</template>

<script>

import {getQueryString, getLocal} from "@/common/js/utils";
import {customerBussiness, AuthWechatShare, getWxUserInfo} from "@/service/MpServer";
import {Dialog, Toast} from "vant";
import {setLocal} from "../../common/js/utils";

export default {
  components: {
  },

  name: 'CusDocDetail',
  data() {
    return {
      weekdays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      isWinXinClient: false,
      isLoading: false,
      doctorInfo: {},
      docDateCalcs: [],
      currentDocDateCalc: {}
    }
  },

  mounted() {
    let app= this;
    let doctorId = "";
    let appid = "";
    if (!getQueryString("share")) {   //名医堂直接调用
      appid = getLocal("login_cus_appid");
      doctorId = this.$route.query.doctorId;
      if (!doctorId)
        doctorId= getLocal("CusDocDetail_DoctorId");

      // 获取医生基本信息与未来几天的排
      getWxUserInfo(function () {
        app.getDoctorInfo(doctorId, function () {
          AuthWechatShare(appid, "CusDocDetail", app.doctorInfo.DOCTOR_NAME, "医生详情",
            app.doctorInfo.DOCTOR_IMG, "doctorId=" + doctorId);
        });
        app.getDocDateCalc(doctorId);
      });
    } else { //其他客户分享来的
      doctorId = getQueryString("doctorId");
      appid= getQueryString("state");
      setLocal("CusDocDetail_DoctorId", doctorId);

      let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri='
        + window.location.href.split('?')[0].replace("#", "%23")
        + '&response_type=code&scope=snsapi_userinfo&state=' + appid + '#wechat_redirect';
      window.location.href = url;
    }
  },

  methods: {
    postBook(){
      if (!this.currentDocDateCalc){
        this.$toast("请先选择挂号日期!");
        return;
      }

      this.$router.push({path: '/CusDocSch', query: { docInfo: JSON.stringify(this.doctorInfo),
          calcInfo: JSON.stringify(this.currentDocDateCalc) }});
    },

    getDateShow(date){
      let dateFmt = new Date(date);
      return (dateFmt.getMonth() + 1) + '-' + dateFmt.getDate();
    },

    getDoctorInfo(doctorId, func) {
      let _this = this;
      let param = {doctor: doctorId};
      customerBussiness("DOCTOR", "getWDOCInfo", param, function (data) {
        let doclist = JSON.parse(data).Table;
        (doclist.length > 0) ? _this.doctorInfo = doclist[0] : {}
        if (func) {
          func();
        }
      });
    },

    getDocDateCalc(doctorId) {
      let _this= this;
      let param = { doctor: doctorId };
      customerBussiness("DOCTOR_SCHEDULE", "getDocDateCalc", param, function (data) {
        _this.docDateCalcs = JSON.parse(data).Table;
        if(_this.docDateCalcs.length > 0){
          _this.currentDocDateCalc = _this.docDateCalcs[0];
        }
      });
    }
  }
}
</script>

<style lang="less" scoped >
  @import '../../common/style/mixin';

  body {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
    font-size: 14px !important;
  }
  .refreshVan{
    overflow: auto;
    background-color: #f1f1f1;
  }
  .dc-card{
    padding: 10px;
    background-color: #FFFFFF;
  }
  .dc-header{
    padding: 10px;
    height: 80px;
  }
  .dc-image{
    height: auto;
    width: 90px;
  }
  .dc-title{
    margin-left: 10px;
    margin-top: 10px;
    .docName{
      font-size: 18px;
      font-weight: 600;
      line-height: 24px;
    }
    .docTech{
      font-size: 15px;
      line-height: 26px;
      color: #999999;
    }
  }

  .menu-title{
    font-weight: 600;
    margin: 2px 2px 10px 5px;
    font-size: 16px;
  }

  .week-title{
    clear: both;
    font-weight: 600;
    margin: 10px 2px 10px 5px;
    font-size: 16px;
  }

  .weeks{
    background-color: #FFFFFF;
    margin-top: 10px;
    padding: 10px 5px;
    .week-item{
      text-align: center;
      width: 60px;
      font-size: 14px;
      display: inline-block;
      .item-value{
        height: 24px;
        line-height: 24px;
      }
    }
    .active{
      background-color: #01BD5D;
      color: #FFFFFF;
    }
  }

  .detail-list{
    margin: 10px 0px;
    background-color: #FFFFFF;
  }
  .detail-item{
    background-color: #01BD5D;
    color: #FFFFFF;
    text-align: center;
    padding: 30px 0;
  }
  .detail-info{
    padding: 5px;
    .info-title{
      font-size: 15px;
      font-weight: 600;
    }
    .info-tag{
      margin: 4px 0;
      font-size: 16px;
      font-weight: 500;
      color: #525252;
      background-color: #f1f1f1;
      width: 100px;
    }
    .info-postion{
      margin: 4px 0;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
    }
    .info-from{
      font-size: 14px;
      font-weight: 600;
    }
  }

  .detail-time{
    margin-top: 12px;
    margin-right: 5px;
    .money{
      color: #FF6B01;
      font-size: 15px;
      text-align: center;
    }
    .appoint{
      color: #FFFFFF;
      background-color: #01BD5D;
      padding: 5px;
      border-radius: 15px;
      text-align: center;
      font-size: 13px;
    }
    .appoint_disable{
      color: #FFFFFF;
      background-color: #797979;
      padding: 5px;
      border-radius: 15px;
      text-align: center;
      font-size: 13px;
    }
    .residue{
      padding: 5px;
      font-size: 12px;
      text-align: center;
      width: 100px;
    }
  }

  .dc-desc{
    padding: 5px 10px;
    background-color: #FFFFFF;
    .desc-title{
      font-size: 16px;
    }
    .desc-content{
      font-size: 14px;
      padding: 8px;
      color: #999999;
      line-height: 20px;
    }
  }

</style>
